import { connect } from 'react-redux';
import {
  downloadTemplate,
  setMassiveLoadType,
} from 'store/vehicles/actions';
import {
  closeConfirmationMessage,
  closeResultMessage,
  openConfirmationMessage,
  downloadTemplateVcMassiveLoad,
  uploadVehicles,
  downloadFailedRecords,
} from 'store/contracts/actions';
import VehicleMassLoad from './VehicleMassLoad';

export default connect(
  (state) => ({
    massiveLoadType: state.vehicles.massiveLoadType,
    massiveRecords: state.contracts.massiveRecords,
    loader: state.contracts.loader,
    resultMessage: state.contracts.resultMessage,
    confirmationMessage: state.contracts.confirmationMessage,
  }),
  {
    closeResultMessage,
    openConfirmationMessage,
    closeConfirmationMessage,
    uploadVehicles,
    downloadFailedRecords,
    downloadTemplate,
    downloadTemplateVcMassiveLoad,
    setMassiveLoadType,
  }
)(VehicleMassLoad);
